import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getEpisodes = (params: any = {}) => {
  let query = new URLSearchParams();
  for (let key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  const url = `${BASE_URL}/api/v1/episodes${queryString ? `?${queryString}` : ""}`;
  return api.get(url);
};

export const getEpisode = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/episodes/${id}`);
};

export const createEpisode = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/episodes`, camelToSnake(payload));
};

export const updateEpisode = (id: number, payload: any) => {
  return api.put(`${BASE_URL}/api/v1/episodes/${id}`, camelToSnake(payload));
};
